import { createContext, useContext } from 'react'

// TODO merge with FEATURES
export const defaultState = {
  history: [],
  // addPath: () => false,
  getLastMatchingPath: () => '',
}

export interface HistoryState {
  history: string[]
  // addPath: (path: string) => void
  getLastMatchingPath: (regexp: RegExp) => string | null
}

export const HistoryContext = createContext<HistoryState>(defaultState)

export function useNavigationHistory() {
  return useContext(HistoryContext)
}
